import * as React from "react";
import { PieChart } from "@mui/x-charts/PieChart";

export default function PieChartComponent({ data }) {
  return (
    <PieChart
      series={[
        {
          data: data.map((item) => ({
            label: item.feedbackType,
            value: item.value,
          })),
          highlightScope: { fade: "global", highlight: "item" },
          faded: { innerRadius: 30, additionalRadius: -30, color: "gray" },
        },
      ]}
      height={250}
    />
  );
}
